import {RequestHandler, RequestOptions} from "./RequestHandler";
import Axios, {CancelTokenSource} from "axios";
export class WpAjaxPost{
    public static ajaxUrl:string;
    constructor()
    {


    }

    public static Post<T=any>(action:string,data:any=null,options?:RequestOptions,files?:any)
    {
        return new RequestHandler<T>(action,data,WpAjaxPost.ajaxUrl,options,files).Execute();
    }

    public static ExternalPost<T=any>(url:string,data:any=null,options?:RequestOptions,files?:any)
    {
        return new RequestHandler<T>('',data,url,options,files).Execute();
    }

    public static async CancellablePost<T>(action:string,data:any={},cancellationToken:CancellationToken,options?:RequestOptions)
    {

        return new RequestHandler<T>(action,data,WpAjaxPost.ajaxUrl,options).ExecuteWithCancellation(cancellationToken);

    }

    public static SetGlobalVar(Variable:any)
    {
        (window as any).RNGlobalVar=Variable;
        WpAjaxPost.ajaxUrl=Variable.ajaxurl;
    }
}



export class CancellationToken{
    public source:CancelTokenSource;

    constructor(){
        this.source=Axios.CancelToken.source();
    }
    public Cancel(){
        this.source.cancel();
    }


}

export interface CancellabeResult<T>{
    wasCancelled:boolean;
    result:T;
}